<div class="sub-header">
  <span class="col-md-12">
    &nbsp;
  </span>
</div>

<h1>{{ 'Token.Error' | translate }}</h1>
